// import external dependencies
import 'jquery';
//import Vue from 'vue';
// Import everything from autoload
import "./autoload/_bootstrap.js"

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import ourBusinessFamily from './routes/business-family';
//import careers from '../vue-components/careers';
/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,

  ourBusinessFamily,

  common,
});

/*let vueMain = new Vue({ el: '#vue-container',
  components: {
    careers,
  },
});
window.refs = vueMain.$refs;*/
// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js